module.exports = __webpack_public_path__ + "static/media/fr-icon.bb508603.png";


//////////////////
// WEBPACK FOOTER
// ./src/wbstdt/imgs/icons/fr-icon.png
// module id = 60
// module chunks = 0